import { useFormik } from "formik"
import React, { useState } from "react"
import ModalComponent from "../../../components/Modal"
import { admin } from "../../../config/apiEndpoints"
import { Row, Col, Form, FloatingLabel, Spinner } from "react-bootstrap"
import { handleOnBlur, handleOnchange } from "../../../lib/GlobalMethods"
import axiosProvider from "../../../lib/AxiosProvider"
import { _numberRegex_ } from "../../../lib/Regex"
import * as Yup from "yup"
import { toast } from "react-toastify"

const AddEditGST = ({
  show,
  handleClose,
  fetchData,
  isUpdateGST,
  setIsUpdateGST,
  userRole,
}) => {
  const [loading, setLoading] = useState(false)

  const validationSchema = Yup.object({
    gst: Yup.string().required("GST is required"),
  })

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: "PATCH",
        endpoint: admin.updateGST,
        data: values,
      })

      if (response?.data?.code === 200 || response?.data?.code === 201) {
        toast.success(response.data.message)
        setLoading(false)
        fetchData()
        handleClose()
        setIsUpdateGST(false)
        resetForm()
      } else {
        setLoading(false)
        throw { message: response?.data?.message }
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.message)
    }
  }

  const formik = useFormik({
    initialValues: {
      gst: isUpdateGST?.gst,
    },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  const { errors, values, touched, setFieldValue, resetForm } = formik

  return (
    <>
      <ModalComponent
        show={show}
        modalsize={"md"}
        backdrop="static"
        animationFade={true}
        onHide={() => {
          handleClose()
          resetForm()
        }}
        modeltitle={"Update GST"}
        submitname={
          loading ? (
            <Spinner size="sm" animation="border" variant="light" />
          ) : userRole?.toLowerCase() !== "super admin" ? (
             false
          ) : "Update"
        }
        handleSubmit={formik.handleSubmit}
        btnclosetext="Cancel"
        children={
          <Form
            noValidate
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault()
              }
            }}
          >
            <Row xs={"auto"}>
              <Col xs={12}>
                <FloatingLabel
                  controlId="gst"
                  label={
                    <>
                      GST (%)<span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    autoComplete="false"
                    type="text"
                    name="gst"
                    placeholder=""
                    className="mb-n1"
                    maxLength={10}
                    disabled={userRole?.toLowerCase() !== "super admin" ? true : false}
                    value={values.gst}
                    onChange={(e) => handleOnchange(e, _numberRegex_, formik)}
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={touched.gst && !!errors.gst}
                    isValid={touched.gst && !errors.gst}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.gst}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>
            </Row>
          </Form>
        }
      />
    </>
  )
}

export default AddEditGST
